import React, { Component } from 'react';
import SurveyService from '../../../../Services/surveyService';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import ProjectAssociableSurveyItem from '../../../../Domain/ProjectAssociableSurveyItem';
import ButtonFooterContainer from '../../../../Elements/ButtonFooterContainer';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ProjectSurveySearchParams from '../../../Operations/Projects/ProjectSurveySearchParams';
import OverWindow from '../../../../Elements/TabList/OverWindow';
import FigmaButton from '../../../../Elements/FigmaButton';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';

class AssociateSurveyPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selectedIndexInSource: -1,
      saving: false,
      surveyData: {
        TemplateId: props.ReportTemplateId,
        SelectedSurveyIds: [],
        selectedSurvey: '',
      },
      filterPanel: {
        Filter: '',
      },
      isOverWindow: true,
      searchItem: new ProjectSurveySearchParams(props.searchItem.CfId),
    };

    ProjectAssociableSurveyItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  componentDidMount() {}

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.SassieId === item.SassieId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });

    const temp = {
      Id: this.props.searchItem.CfId,
      EntityId: this.state.itemList.find((f) => f.Selected).SurveyId,
      SassieId: this.state.itemList.find((f) => f.Selected).SassieId,
    };

    ErrorMessage.SetNotification(
      'The survey association process started in the background. This might take some time, you will be notified via in-app notification when the process has finished.'
    );
    SurveyService.AssociateProjectSurvey(temp)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification(
            `The survey ${temp.SassieId} has been successfully associated with the project ${this.props.searchItem.CfId}.`
          );
        }
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: ASP88. Survey association failed. Please notify IT!');
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Submit'
          submit={true}
          icon={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={this.handleOnSubmit.bind(this)}
        />
      </ButtonFooterContainer>
    );
  }

  changeOfEdited(fieldName, newValue) {
    const tempItem = {
      ...this.state.filterPanel,
      [fieldName]: newValue,
    };

    this.setState({ filterPanel: tempItem });
  }

  render() {
    if (this.props.isOverWindow) {
      return (
        <OverWindow
          title={'Apply Survey'}
          clickOnCancel={() => {
            if (!this.state.saving) this.props.clickOnCancel(false);
          }}
          closeOnClickOutside={false}
          iconName='fa-solid fa-plus-circle'
          zIndex={1050}
          className='applySurveyPanel top-of-boxFigma'
          verticalScroll={false}
        >
          <div className='container-fluid verticalScrollForSearch height50vh'>
            <TabOfDataTable
              itemList={this.state.itemList}
              type={ProjectAssociableSurveyItem}
              serviceFunction={SurveyService.GetAvailableSurveys}
              changeOfItemListFunction={(itemList) => this.setState({ itemList })}
              convertDBItemsFunction={SurveyService.ConvertProjectSurveyDBItem}
              showSearchStrip={true}
              singleSearchLinePlaceholder='Search in Survey ID, Name or Current Projects...'
              singleSearchLine={true}
              enableUrlPush={false}
              searchParamsType={ProjectSurveySearchParams}
              clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
              searchItem={this.state.searchItem}
              isFilterDisabled={true}
              isRefreshDisabled={true}
            />
            {this.renderCancelAndSubmitButtons()}
          </div>
        </OverWindow>
      );
    }
  }
}

export default AssociateSurveyPanel;
